import styled from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { SelectComponentProps } from "./types";
import { alpha } from "../../../typography";
import { styleWrappedComponent } from "./styleWrappedComponent";

const StyledNoOptionsMessage = styled.div`
  ${styleWrappedComponent(alpha.primaryInactive.body2)};
`;

type NoOptionsMessageProps = SelectComponentProps["NoOptionsMessage"];

export const NoOptionsMessage: FC<NoOptionsMessageProps> = ({
  children,
  ...props
}) => (
  <StyledNoOptionsMessage>
    <components.NoOptionsMessage {...props}>
      {children}
    </components.NoOptionsMessage>
  </StyledNoOptionsMessage>
);
